let pebbleScrollHandler = null;
let pebbleResizeHandler = null;
let pebbleResizeObserver = null;
let pebbleSubmenuTimer = null;

function getHeroElement() {
  const overlay = document.querySelector('[data-header-overlay="true"]');
  if (!overlay) return null;
  return overlay.closest('.shopify-section') || overlay;
}

function isPastHero(hero) {
  // Déclenche l’état “expanded” dès le début du scroll, pas seulement hors hero
  const threshold = 16;
  if (window.scrollY <= threshold) return false;
  return true;
}

function isMobilePebbleHeader() {
  return window.matchMedia('(max-width: 779px)').matches;
}

function isPebbleHomeWithHero() {
  return document.body.classList.contains('template-index') && getHeroElement();
}

function getPebbleMenuChild(link) {
  let sibling = link.nextElementSibling;
  while (sibling) {
    if (sibling.classList?.contains('header__menu-child')) return sibling;
    sibling = sibling.nextElementSibling;
  }
  return link.closest('.flex__item')?.querySelector(':scope > .header__menu-child') || null;
}

function repositionPebbleSubmenus() {
  const header = document.querySelector('#shopify-header-section.header--pebble');
  if (!header || isMobilePebbleHeader()) return;

  const menuSection = header.querySelector('.menu-section');
  const bar = header.querySelector('.header-pebble-bar .page-width') || menuSection;
  if (!menuSection || !bar) return;

  const barRect = bar.getBoundingClientRect();
  const viewportLeft = 16;
  const viewportRight = document.documentElement.clientWidth - 16;
  const viewportBottom = window.innerHeight - 16;

  menuSection.querySelectorAll('.header__menu a.header__link').forEach((link) => {
    const child = getPebbleMenuChild(link);
    if (!child) return;

    const item = link.closest('.flex__item') || link;
    const itemRect = item.getBoundingClientRect();
    const childWidth = Math.min(Math.max(child.offsetWidth || 0, 228), viewportRight - viewportLeft);
    let left = itemRect.left;
    if (left + childWidth > viewportRight) {
      left = Math.max(viewportLeft, itemRect.right - childWidth);
    }
    left = Math.min(Math.max(left, viewportLeft), Math.max(viewportLeft, viewportRight - childWidth));

    const childHeight = child.offsetHeight || 0;
    let top = barRect.bottom + 8;
    if (childHeight && top + childHeight > viewportBottom) {
      top = Math.max(16, viewportBottom - childHeight);
    }
    const maxHeight = Math.max(80, viewportBottom - top);

    child.style.position = 'fixed';
    child.style.top = `${Math.round(top)}px`;
    child.style.left = `${Math.round(left)}px`;
    child.style.right = 'auto';
    child.style.bottom = 'auto';
    child.style.maxHeight = `${Math.round(maxHeight)}px`;
    child.style.overflowX = 'hidden';
    child.style.overflowY = 'auto';
    child.style.zIndex = '240';

    const pseudo = link.querySelector('span.pseudo-megamenu');
    if (pseudo) {
      const bridgeTop = itemRect.bottom;
      const bridgeHeight = Math.max(8, barRect.bottom + 10 - bridgeTop);
      pseudo.style.position = 'fixed';
      pseudo.style.left = `${Math.round(itemRect.left)}px`;
      pseudo.style.width = `${Math.round(itemRect.width)}px`;
      pseudo.style.top = `${Math.round(bridgeTop)}px`;
      pseudo.style.height = `${Math.round(bridgeHeight)}px`;
      pseudo.style.transform = 'none';
      pseudo.style.zIndex = '230';
    }
  });
}

function syncPebbleMenuFit() {
  const wrap = document.querySelector('#shopify-header-section.header--pebble .header-pebble-nav__menu');
  // Jamais 2 rangées : trop étroit = burger, assez large = une seule ligne.
  wrap?.classList.remove('is-compact');
}

function schedulePebbleSubmenuReposition() {
  repositionPebbleSubmenus();
  window.requestAnimationFrame(repositionPebbleSubmenus);
  window.clearTimeout(pebbleSubmenuTimer);
  // Suit la transition max-width du header (0.4s)
  pebbleSubmenuTimer = window.setTimeout(repositionPebbleSubmenus, 450);
}

function bindPebbleSubmenuTracking(header) {
  const menuSection = header.querySelector('.menu-section');
  if (!menuSection) return;

  menuSection.querySelectorAll('.header__menu a.header__link').forEach((link) => {
    if (!getPebbleMenuChild(link) || link.dataset.pebbleSubmenuBound === 'true') return;
    link.dataset.pebbleSubmenuBound = 'true';
    link.addEventListener('mouseenter', repositionPebbleSubmenus);
    link.addEventListener('focus', repositionPebbleSubmenus);
  });

  const bar = header.querySelector('.header-pebble-bar .page-width');
  if (bar && bar.dataset.pebbleSubmenuTransitionBound !== 'true') {
    bar.dataset.pebbleSubmenuTransitionBound = 'true';
    bar.addEventListener('transitionend', (event) => {
      if (event.propertyName === 'max-width' || event.propertyName === 'margin-top') {
        syncPebbleMenuFit();
        repositionPebbleSubmenus();
      }
    });
  }
}

function initPebbleMenuAria() {
  const details = document.querySelector('menu-drawer[data-menu-button="true"] details.menu-drawer_details');
  const burger = document.querySelector('.header-pebble-nav__burger');

  if (!details || !burger || details.dataset.pebbleMenuAriaBound === 'true') return;

  details.dataset.pebbleMenuAriaBound = 'true';

  const syncAria = () => {
    burger.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
  };

  details.addEventListener('toggle', syncAria);
  syncAria();
}

function initPebbleHeaderScroll() {
  const header = document.querySelector('#shopify-header-section.header--pebble');
  if (!header) return;

  initPebbleMenuAria();
  bindPebbleSubmenuTracking(header);

  const hero = getHeroElement();

  if (pebbleScrollHandler) {
    window.removeEventListener('scroll', pebbleScrollHandler);
  }

  if (pebbleResizeHandler) {
    window.removeEventListener('resize', pebbleResizeHandler);
    window.removeEventListener('load', pebbleResizeHandler);
  }

  if (pebbleResizeObserver) {
    pebbleResizeObserver.disconnect();
    pebbleResizeObserver = null;
  }

  let lastHeaderHeight = -1;

  const updateHeaderState = () => {
    if (isMobilePebbleHeader()) {
      header.classList.remove('header--pebble-scrolled');
      header.classList.remove('shopify-section-header-hidden');
    } else if (isPebbleHomeWithHero()) {
      const scrolled = isPastHero(hero);
      header.classList.toggle('header--pebble-scrolled', scrolled);

      if (scrolled) {
        header.classList.remove('shopify-section-header-hidden');
      }
    } else {
      header.classList.add('header--pebble-scrolled');
      header.classList.remove('shopify-section-header-hidden');
    }

    syncPebbleMenuFit();
    const height = header.offsetHeight;
    if (height !== lastHeaderHeight) {
      lastHeaderHeight = height;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }
    schedulePebbleSubmenuReposition();
  };

  pebbleScrollHandler = updateHeaderState;
  pebbleResizeHandler = updateHeaderState;

  window.addEventListener('scroll', pebbleScrollHandler, { passive: true });
  window.addEventListener('resize', pebbleResizeHandler, { passive: true });
  window.addEventListener('load', pebbleResizeHandler, { passive: true });
  updateHeaderState();

  if (window.ResizeObserver && hero) {
    pebbleResizeObserver = new ResizeObserver(updateHeaderState);
    pebbleResizeObserver.observe(hero);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPebbleHeaderScroll);
} else {
  initPebbleHeaderScroll();
}

document.addEventListener('initOverlay', initPebbleHeaderScroll);
document.addEventListener('shopify:section:load', initPebbleHeaderScroll);
